import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as moment from "moment";

export interface AddNoteDialogData {
  usernamee: string;
}

@Component({
  selector: "app-add-note-dialog",
  templateUrl: "./add-note-dialog.component.html",
})
export class AddNoteDialogComponent {
  note = "";

  constructor(
    public dialogRef: MatDialogRef<AddNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddNoteDialogData
  ) {}

  // disable Done until there is non-whitespace content
  get isEmpty(): boolean {
    return !this.note || !this.note.trim();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  // build the stamped line and return it; parent prepends it to the field
  onDone(): void {
    if (this.isEmpty) {
      return;
    }
    const timestamp = moment().format("M/D/YYYY h:mm A");
    const stamped = `${this.data.usernamee} ${timestamp}: ${this.note.trim()}`;
    this.dialogRef.close(stamped);
  }
}
